import { render, staticRenderFns } from "./TreatmentLoopItem.vue?vue&type=template&id=c6a64f0e&"
import script from "./TreatmentLoopItem.vue?vue&type=script&lang=js&"
export * from "./TreatmentLoopItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports